
import {createSlice} from "@reduxjs/toolkit";

export const helperSlice = createSlice({
    name: 'helperSlc',
    initialState: {value: {
            content: null,
            contentClean: null,
            label: null,
            royalty: null,
            min: null,
            max: null,
            fromAmount: null,
            toAmount: null,
            dateFrom: null,
            dateTo: null,
            accountAction: "Includes",
            marketAction: "Includes",
            distributionChannelAction: "Includes",
            regionAction: "Includes",
            countryAction: "Includes",
            languageAction: "Includes",
            share: null,
            netShare: null,
            summaryExpression: null,
            sumSign: "4563",
            distributionFee: null,
            distributionFeeMulti: [],
            overheadFee: null,
            overheadFeeMulti: [],
            distFeePct: null,
            overheadFeePct: null,


            maxNet: null,
            maxShare: null,
            maxGross: null,
            grossesMapping: null,
            expensesMapping: null,
            bonusMapping: null,

            maxFee: null,
            maxAmount: null,
            maxBasisAmount: null,
            maxResultPct: null,
            maxResultLimiter:  [],

            maxBasis: null,
            maxBasisPct: null,
            maxBasisLimiter: [],

            overheadSubToMax: null,

            overheadMaxFee: null,
            overheadMaxFeePct: null,
            overheadMaxFeeLimiter:  [],
            overheadMaxBasis: null,
            overheadMaxBasisPct: null,
            overheadMaxBasisLimiter:  [],


        }},
    reducers:
        {
            changeHelper: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeHelper } = helperSlice.actions;

export default  helperSlice.reducer ;
